function getCustomisedReactionsPath(spotId) {
  switch (process.env.NODE_ENV) {
    case 'development':
      return `http://localhost:9292/${spotId}/upload`;
    default:
      return `https://uploader.spot.im/${spotId}/upload`;
  }
}

export default async function sendFileToServer(spotId, newReaction) {
  const formData = new FormData();
  const keys = Object.keys(newReaction);
  keys.forEach(key => formData.append(key, newReaction[key]));
  const response = await fetch(getCustomisedReactionsPath(spotId), {
    method: 'POST',
    body: formData
  });
  const fileName = await response.json();
  return fileName;
}
